import { render, staticRenderFns } from "./ElderNursingList.vue?vue&type=template&id=e108cb2a&scoped=true"
import script from "./ElderNursingList.vue?vue&type=script&lang=js"
export * from "./ElderNursingList.vue?vue&type=script&lang=js"
import style0 from "./ElderNursingList.vue?vue&type=style&index=0&id=e108cb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e108cb2a",
  null
  
)

export default component.exports